import { GraphQLError } from 'graphql'

export function isAbortError (err) {
  return err?.name === 'AbortError'
}

// Postgres 23505 / Prisma P2002, across the shapes a raw-query violation can
// surface in (direct code, wrapped cause, or message text) — used by the tip
// claim paths (webhook + reconcilePendingTips) to fold a txHash unique
// collision into a clean no-op instead of an unhandled 500 the caller retries
// forever (one tx = one credit, the global ObservedTip.txHash unique).
export function isUniqueViolation (err) {
  if (!err) return false
  const codes = [err.code, err?.cause?.code, err?.meta?.cause?.code]
  if (codes.includes('P2002') || codes.includes('23505')) return true
  return /unique constraint|duplicate key|unique_violation/i.test(String(err?.message || ''))
}

export const E_FORBIDDEN = 'E_FORBIDDEN'
export const E_UNAUTHENTICATED = 'E_UNAUTHENTICATED'
export const E_BAD_INPUT = 'E_BAD_INPUT'
export const E_VAULT_KEY_EXISTS = 'E_VAULT_KEY_EXISTS'
export const E_PAY_IN_RETRY_RACE = 'E_PAY_IN_RETRY_RACE'

export class GqlAuthorizationError extends GraphQLError {
  constructor (message) {
    super(message, { extensions: { code: E_FORBIDDEN } })
  }
}

export class GqlAuthenticationError extends GraphQLError {
  constructor () {
    super('you must be logged in', { extensions: { code: E_UNAUTHENTICATED } })
  }
}

export class GqlInputError extends GraphQLError {
  constructor (message, code) {
    super(message, { extensions: { code: code || E_BAD_INPUT } })
  }
}

// a payIn retry lost a benign race (lineage already advanced, successor not FAILED yet,
// or a concurrent retry won the successorId lock) — clients key on the code to suppress it
export class GqlPayInRetryRaceError extends GraphQLError {
  constructor (message) {
    super(message, { extensions: { code: E_PAY_IN_RETRY_RACE } })
  }
}
